export enum ArrowState {
  DOWN = 'arrow-down-icon-black',
  UP = 'arrow-up-icon-black',
}

export interface MenuOption {
  key: string;
  value: string;
  states?: StateOption[];
}

export interface StateOption {
  key: string;
  value: string;
}

export enum MenuPosition {
  ABOVE = 'above',
  BELOW = 'below',
}
